import axios from 'axios';
import { web3Api } from 'store/web3Api';
import { RESTRICTED_COUNTRIES_CODES } from '../const';
import { queryFnNotifyWrapper } from '../utils/queryFnNotifyWrapper';
import { getCountryCode, getCountryCodeViaBigData, isUkCountry } from 'modules/api/getCountryCode';

type Args = string[] | void;

interface IGetAccessInfoResponse {
  isAccessAllowed: boolean;
  isDisclaimerRequired: boolean;
}

export const { useGetAccessInfoQuery } = web3Api.injectEndpoints({
  endpoints: build => ({
    getAccessInfo: build.query<IGetAccessInfoResponse, Args>({
      queryFn: queryFnNotifyWrapper<Args, never, IGetAccessInfoResponse>(
        async (countryCodes?: Args) => {

          const countryCode = await (async () => {
            try {
              return await getCountryCodeViaBigData();

            } catch (error) {
              try {

                return await getCountryCode();
              } catch (error) {
                const response = await axios.get(
                  `${import.meta.env.VITE_HOMEPAGE}country.json`,
                );

                console.log(response.headers['cloudfront-viewer-country']);

                return response.headers['cloudfront-viewer-country'];
              }
            }
          })();

          const upperCasedCountryCode = countryCode?.toUpperCase();
          const codesToCheck = countryCodes ?? RESTRICTED_COUNTRIES_CODES;

          return {
            data: {
              isAccessAllowed: !codesToCheck.includes(upperCasedCountryCode),
              isDisclaimerRequired: isUkCountry(upperCasedCountryCode),
            },
          };
        },
      ),
    }),
  }),
});
